module.exports = __webpack_public_path__ + "img/rep-gogliuzza.c99f5d24.jpg";